import React, { useState, useEffect } from 'react';
import { api, useServer } from '../contexts/ServerContext';
import { Tag } from 'lucide-react';

function PlayerTagsDisplay({ steamId }) {
  const { server } = useServer();
  const [playerTags, setPlayerTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPlayerTags();
  }, [steamId, server]);

  const fetchPlayerTags = async () => {
    try {
      // console.log('PlayerTagsDisplay: получаем теги для', steamId);
      const response = await api.get(`/api/tags/player/${steamId}?server=${server}`);
      // console.log('PlayerTagsDisplay: теги получены', response.data);
      setPlayerTags(response.data);
    } catch (error) {
      console.error('PlayerTagsDisplay: ошибка при получении тегов игрока:', error);
      console.error('PlayerTagsDisplay: детали ошибки:', error.response?.data);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="animate-pulse bg-gmod-lighter h-4 w-16 rounded"></div>;
  }

  if (playerTags.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {playerTags.map((tag) => (
        <div
          key={tag.id}
          className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border"
          style={{
            backgroundColor: `${tag.color}20`,
            color: tag.color,
            borderColor: `${tag.color}40`
          }}
          title={tag.description || tag.name}
        >
          <Tag size={10} />
          {tag.name}
        </div>
      ))}
    </div>
  );
}

export default PlayerTagsDisplay; 